module.exports = __webpack_public_path__ + "static/media/preview-social-icons-instagram.a614895c.svg";